import { render, staticRenderFns } from "./Single-Project-Detail.vue?vue&type=template&id=945c75f6"
import script from "./Single-Project-Detail.vue?vue&type=script&lang=js"
export * from "./Single-Project-Detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports